import {GameInfo} from '../../../games/game-info';
import {IArenaGameFiltersCategory} from "../../arena-filters/categories/arena-game-filters-category.interface";
import {computed} from "mobx";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {GameFilterDefinitionBase} from "../game-filter-definition-base";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

/**
 * This class is used to apply a filter that does something like this:
 * Show all games that doesn't fall in any of the other available games filters categories for the current arena
 */

export class OtherFilterDefinition extends GameFilterDefinitionBase {
  constructor(services: IServiceFactoryExtended, private readonly allOthersCategories: IArenaGameFiltersCategory[]) {
    super(services);
  }

  get id(): string {
    return 'other';
  }

  get text(): string {
    return this.services.translation.translate('OTHER');
  }


  @computed
  get currentArenaCategories(): IArenaGameFiltersCategory[] {
    return this.allOthersCategories.filter(c => c.availableFilters.length > 0);
  }

  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    const categoriesInCurrentArena = this.currentArenaCategories;
    for(let category of categoriesInCurrentArena) {
      if(category.isGameIncludedInThisCategory(gameInfo)) {
        return ApplyGameFilterResult.ExcludeGame;
      }
    }

    return ApplyGameFilterResult.IncludeGame;
  }

}
